import { resolveImageReference, resolveRTC, resolveString } from '@/utils/resolvers';

export default function resolver(appsDocumentData: any, page: any) {
  const { contentList, listTitle } = appsDocumentData as ContentListType;

  const parseMenuItem = ({
    openInNewWindow,
    iconType = '',
    iconLink = '',
    iconText = {},
    icon = {},
  }: any) => {
    const { image } = icon;
    const imageUrl = resolveImageReference({ rawVal: image, page })?.original?.url;

    return {
      icon: {
        type: resolveString({ rawVal: iconType }),
        text: resolveRTC({ rawVal: iconText }),
        url: imageUrl,
      },
      link: {
        href: iconLink,
        openInNewWindow,
      },
    };
  };

  const parseContent = ({ menuItems = [], groupTitle = '' }: any) => {
    return {
      menuItems: menuItems.map(parseMenuItem),
      groupTitle,
    };
  };

  return {
    listTitle,
    contentList: contentList?.map(parseContent),
  };
}
